import { getRequest } from "./api";

export let initComponent;
export const initMenu = async (router, store) => {
    if (store.state.routes.length > 0) {
        if (router.currentRoute.fullPath === "/home") {
            return;
        }
        if (router.options.routes && router.options.routes.length <= 4) {
            setTimeout(() => {
                // router.addRoutes(JSON.parse(window.sessionStorage.getItem("dynamicRoutes")));
                return;
            }, 10);
        } else {
            return;
        }

  }

    await getRequest("/menu/menustart?userId=" + store.getters.getUserId, null, store.getters.getUserToken).then(data => {
      if (data.success) {
        let fmtRoutes = formatRoutes(data.result.menuList);
        // window.sessionStorage.setItem("dynamicRoutes", JSON.stringify(fmtRoutes));
        store.commit('initRoutes', fmtRoutes);
        router.addRoutes(fmtRoutes);
        initComponent = data.result.initComponent
        //router.replace(data.result.initComponent);
        } else {
            router.replace("/");
        }
    })
}
export const formatRoutes = (routes) => {
  let fmRoutes = [];
    routes.forEach(router => {
        let {
            path,
            component,
            name,
            meta,
            iconCls,
            children
        } = router;
        if (children && children instanceof Array) {
            children = formatRoutes(children);
        }
        let fmRouter = {
            path: path,
            name: name,
            iconCls: iconCls,
            meta: meta,
            children: children,
            component(resolve) {
                if (component.startsWith("Home")) {
                    require(['../views/' + component + '.vue'], resolve);
                } else if (component.startsWith("Notice")) {
                    require(['../views/notice/' + component + '.vue'], resolve);
                } else if (component.startsWith("Meal")) {
                    require(['../views/meal/' + component + '.vue'], resolve);
                } else if (component.startsWith("Salary")) {
                    require(['../views/salary/' + component + '.vue'], resolve);
                } else if (component.startsWith("Building")) {
                    require(['../views/building/' + component + '.vue'], resolve);
                } else if (component.startsWith("Dormitory")) {
                    require(['../views/dormitory/' + component + '.vue'], resolve);
                } else if (component.startsWith("Master")) {
                    require(['../views/master/' + component + '.vue'], resolve);
                } else if (component.startsWith("User")) {
                    require(['../views/user/' + component + '.vue'], resolve);
                } else if (component.startsWith("Visitor")) {
                   require(['../views/visitor/' + component + '.vue'], resolve);
                }
            }
        }
        fmRoutes.push(fmRouter);
    })
    return fmRoutes;
}